"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderAppSwitcher = exports.AppSwitcherComponent = void 0;
var app_1 = require("app");
var React = __importStar(require("react"));
var ReactDOM = __importStar(require("react-dom"));
var _1 = require("./");
var client_1 = require("react-dom/client");
var AppSwitcherComponent = /** @class */ (function (_super) {
    __extends(AppSwitcherComponent, _super);
    function AppSwitcherComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.documentBody = document.querySelector("body");
        _this.switcherWrapperSelector = ".header__app-switcher__desktop-wrapper";
        _this.closeOnResize = (0, app_1.throttle)(function () {
            if ((0, app_1.detectBreakpoint)(6 /* Breakpoint.SMScreen */) && _this.state.visibleSwitcherMenu === true) {
                _this.closeMenu();
            }
        }, 100);
        _this.toggleAppSwitcher = function () {
            _this.setState(function (prevState) { return ({
                visibleSwitcherMenu: !prevState.visibleSwitcherMenu
            }); });
        };
        _this.closeMenu = function () {
            _this.setState({ visibleSwitcherMenu: false });
        };
        _this.getRef = function (el) {
            _this.$switcher = $(el);
        };
        _this.handleClick = function (e) {
            if (!_this.$switcher || (0, app_1.detectBreakpoint)(6 /* Breakpoint.SMScreen */)) {
                return null;
            }
            var visibleSwitcherMenu = _this.state.visibleSwitcherMenu;
            var withinSwitcher = _this.$switcher.has(e.target).length > 0;
            var $target = $(e.target);
            if (visibleSwitcherMenu &&
                ((withinSwitcher && !$target.parents().hasClass("header__app-switcher__wrapper")) ||
                    (!withinSwitcher && !$target.parents().hasClass("header__menu__item--app__switcher")))) {
                _this.closeMenu();
            }
        };
        _this.switcherWrapper = $(_this.switcherWrapperSelector).get(0);
        _this.state = {
            visibleSwitcherMenu: false
        };
        return _this;
    }
    AppSwitcherComponent.prototype.componentDidMount = function () {
        window.addEventListener("resize", this.closeOnResize);
        this.documentBody.addEventListener("click", this.handleClick);
    };
    AppSwitcherComponent.prototype.componentWillUnmount = function () {
        var _a;
        window.removeEventListener("resize", this.closeOnResize);
        this.documentBody.removeEventListener("click", this.handleClick);
        var externalResource = document.getElementById("consent-file");
        (_a = externalResource === null || externalResource === void 0 ? void 0 : externalResource.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(externalResource);
    };
    AppSwitcherComponent.prototype.render = function () {
        return (React.createElement("div", null,
            !!this.props.language && (0, _1.AppSwitcherButton)({
                language: this.props.language,
                onClick: _1.AppSwitcherService.HasItems() ? this.toggleAppSwitcher : null,
                extraClass: _1.AppSwitcherService.HasItems() ? "" : "not-link",
            }),
            this.renderSwitcher()));
    };
    AppSwitcherComponent.prototype.renderSwitcher = function () {
        if (!this.state.visibleSwitcherMenu) {
            return null;
        }
        var appSwitcher = (React.createElement("div", { className: "header__app-switcher__wrapper", ref: this.getRef },
            React.createElement("div", { className: "container-fluid" },
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "header__app-switcher__content-wrapper" }, this.renderAppSwitcher())))));
        return ReactDOM.createPortal(appSwitcher, this.switcherWrapper);
    };
    AppSwitcherComponent.prototype.renderAppSwitcher = function () {
        var appData = _1.AppSwitcherService.GetData();
        return (0, _1.AppSwitcherItemsList)({
            itemClass: "menu-group__item switcher-item",
            items: appData,
            listClass: "menu-items switcher-items",
            userId: this.props.googleAnalytics.googleAnalyticsUserId
        });
    };
    return AppSwitcherComponent;
}(React.Component));
exports.AppSwitcherComponent = AppSwitcherComponent;
function RenderAppSwitcher(data, element) {
    var root = (0, client_1.createRoot)(element);
    root.render(React.createElement(AppSwitcherComponent, __assign({}, data)));
}
exports.RenderAppSwitcher = RenderAppSwitcher;
